export var HoursStatus;
(function (HoursStatus) {
    HoursStatus[HoursStatus["Open"] = 0] = "Open";
    HoursStatus[HoursStatus["Complete"] = 1] = "Complete";
    HoursStatus[HoursStatus["Pending"] = 2] = "Pending";
    HoursStatus[HoursStatus["Approved"] = 3] = "Approved";
    HoursStatus[HoursStatus["Rejected"] = 4] = "Rejected";
})(HoursStatus || (HoursStatus = {}));
